module.exports = __webpack_public_path__ + "img/completed_thanks_text.c0f97cfb.svg";